// src/components/Login.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import citadelLogo from '../assets/citadelogo.png';

const Login = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) navigate('/dashboard');
  }, [navigate]);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://clinic123.onrender.com/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      // Handle unverified admin
      if (response.status === 403 && data.error?.includes('Admin not verified')) {
        localStorage.setItem('adminEmail', credentials.email);
        sessionStorage.setItem('adminEmail', credentials.email); // ✅ Add this line
        alert('A verification code has been sent to your email. Please verify to continue.');
        navigate('/verify-admin-code');
        return;
      }

      if (response.ok) {
        const { token, user } = data;

        localStorage.setItem('token', token);
        localStorage.setItem('userId', user._id);
        localStorage.setItem('userRole', user.role);
        localStorage.setItem('department', user.department);
        localStorage.setItem('firstName', user.firstName || '');
        localStorage.setItem('lastName', user.lastName || '');

        navigate('/dashboard');
      } else {
        alert(data.error || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('An error occurred during login');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img src={citadelLogo} alt="Citadel Logo" className="login-logo" />
          <h2>Citadel of Grace</h2>
          <h3>Admin Login</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" value={credentials.email} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="show-password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)' }}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <button type="submit" className="login-button">Login</button>

          <div style={{ marginTop: '1rem', textAlign: 'center' }}>
            <span
              onClick={() => navigate('/forgot-password')}
              style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
            >
              Forgot Password?
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
